{#if tag === 'article'}
  <article on:click data-node-id={nodeId} {id} data-allow-background={dataAllowBackground} data-target={dataTarget} class={className}><slot /></article>
{:else if tag === 'aside'}
  <aside on:click data-node-id={nodeId} {id} data-allow-background={dataAllowBackground} data-target={dataTarget} class={className}><slot /></aside>
{:else if tag === 'footer'}
  <footer on:click data-node-id={nodeId} {id} data-allow-background={dataAllowBackground} data-target={dataTarget} class={className}><slot /></footer>
{:else if tag === 'header'}
  <header on:click data-node-id={nodeId} {id} data-allow-background={dataAllowBackground} data-target={dataTarget} class={className}><slot /></header>
{:else if tag === 'main'}
  <main on:click data-node-id={nodeId} {id} data-allow-background={dataAllowBackground} data-target={dataTarget} class={className}><slot /></main>
{:else if tag === 'nav'}
  <nav on:click data-node-id={nodeId} {id} data-allow-background={dataAllowBackground} data-target={dataTarget} class={className}><slot /></nav>
{:else if tag === 'section'}
  <section on:click data-node-id={nodeId} {id} data-allow-background={dataAllowBackground} data-target={dataTarget} class={className}><slot /></section>
{:else}
  <div on:click data-node-id={nodeId} {id} data-allow-background={dataAllowBackground} data-target={dataTarget} class={className}><slot /></div>
{/if}

<script>
  export let className = ''
  export let tag = ''
  export let dataTarget = ''
  export let nodeId = ''
  export let id = ''
  export let dataAllowBackground = false
</script>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>